module.exports = __webpack_public_path__ + "static/media/Sample.3065b72f.xls";